import '../assets/edit.scss'
import TomSPrettyList from './toms-pretty-list'

import React from "react";

function EditTomSPrettyList(tomsProps) {
    //console.log(tomsProps)
    return (
    <>
    <div className="toms-pretty-list">
        <TomSPrettyList {...tomsProps}/>
    </div>
    </>
    )
}

export default EditTomSPrettyList;